export default function detection(agent) {
  	let comp_agent = false;
	comp_agent = agent.indexOf('stbztezxv10') != -1;
	if (comp_agent) {
	  console.info('[ZTE detection] detected');
	}
  	return comp_agent;
}



// WEBPACK FOOTER //
// ./src/devices/zte/detection.js